/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran thru claudes code refactoring tool

// redesign this component to look more elegant and polished
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.
// use tailwind css in the className directive 
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."
// Give me the complete code with instructions


// i am getting this error when i refresh the page
// value (100) is bigger than max (55)
// RangeError: value (100) is bigger than max (55)
// give me the releavnt code to fix this with instructions



import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Range } from 'react-range';

import { IoIosArrowForward } from "react-icons/io";
import { AiFillStar } from 'react-icons/ai';
import { CiStar } from 'react-icons/ci';
import { BsFillGridFill } from 'react-icons/bs';
import { FaThList } from 'react-icons/fa';

import { price_range_product, query_products } from '../store/reducers/homeReducer';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Products from '../components/products/Products';
import Pagination from '../components/Pagination';
import ShopBanner from '../components/ShopBanner';
import ShopProductGridListView from '../components/products/ShopProductGridListView';
import GetSellerConfig from '../components/GetSellerConfig';

import config from '../config';

// ─── Reusable star rating row ────────────────────────────────────────────────
const StarRating = ({ value, onSelect, primaryColor }) => {
  const stars = Array.from({ length: 5 }, (_, i) =>
    i < value
      ? <AiFillStar key={i} />
      : <CiStar key={i} />
  );

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={`Filter by ${value} star${value !== 1 ? 's' : ''} and above`}
      onClick={() => onSelect(value)}
      onKeyDown={(e) => e.key === 'Enter' && onSelect(value)}
      className="text-orange-500 flex justify-start items-center gap-2 text-xl cursor-pointer
                 hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-orange-300 rounded"
    >
      {stars}
    </div>
  );
};

// ─── Main component ──────────────────────────────────────────────────────────
const MainIngredientShop = () => {
  const sellerFrontendURL      = config.STR_FRONTEND_URL;
  const intPriceRangeStep      = config.INT_FRONTEND_PRICE_RANGE_STEP;

  const { products, priceRange, latest_product, totalProduct, parPage } =
    useSelector((state) => state.home);
  const { seller } = useSelector((state) => state.seller);
  const { sellerComponentBackgroundColor } = GetSellerConfig();

  const sellerId                          = seller?._id;
  const sellerPrimaryColor1               = seller?.frontEndPrimaryColor1;
  const sellerSecondaryColor1             = seller?.frontEndSecondaryColor1;

  const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];
  const sellerColorSuffixDark   = sellerArrHexOpacityColorSuffixes[0] || 'FF';
  const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
  const sellerColorSuffixLight  = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
  const sellerProductTerm                 = seller?.productTerm;
  const sellerProductPluralTerm           = seller?.productPluralTerm;
  const sellerMainIngredientTerm          = seller?.mainIngredientTerm;
  const sellerBoolShowSitePayments        = seller?.isVisibleSitePayments === 'Show';
  const sellerBoolShowSiteRating          = seller?.isVisibleSiteRating === 'Show';
  const sellerBoolShowSiteProductsUnderFilter = seller?.isVisibleSiteProductsUnderFilter === 'Show';
  
  // Sidebar is visible only when ALL three optional sections are hidden
  const sellerBoolShowSidebar =
    !sellerBoolShowSitePayments &&
    !sellerBoolShowSiteRating &&
    !sellerBoolShowSiteProductsUnderFilter;

  const [searchParams] = useSearchParams();
  const mainIngredient = searchParams.get('mainIngredient') ?? '';

  // Filters that aren't driven by URL params
  const [FMP, setFmp]                           = useState('');
  const [cookingMethod, setCookingMethod]       = useState('');
  const [byThePan, setByThePan]                 = useState('');
  const [dietaryRestrictions, setDietaryRestrictions] = useState('');
  const [cuisineType, setCuisineType]           = useState('');
  const [holiday, setHoliday]                   = useState('');

  const dispatch = useDispatch();

  // Safe price-range defaults (avoids NaN when priceRange hasn't loaded yet)
  const low  = priceRange?.low  ?? 0;
  const high = priceRange?.high ?? 1000;

  const [filter, setFilter]   = useState(true);
  //const [priceState, setPriceState] = useState({ values: [low, high] });
  const [priceState, setPriceState] = useState(null);

  const [rating, setRating]   = useState('');
  const [styles, setStyles]   = useState('grid');
  const [pageNumber, setPageNumber] = useState(1);
  const [sortPrice, setSortPrice]   = useState('');

  // Fetch price range on mount
  useEffect(() => {
    dispatch(price_range_product(sellerFrontendURL));
  }, [dispatch, sellerFrontendURL]);


  useEffect(() => {
    if (priceRange?.low != null && priceRange?.high != null) {
      setPriceState((prev) => {
        // If already set by user interaction, clamp to valid range
        if (prev) {
          return {
            values: [
              Math.min(Math.max(prev.values[0], priceRange.low), priceRange.high),
              Math.min(Math.max(prev.values[1], priceRange.low), priceRange.high),
            ],
          };
        }
        // First load: initialize to full range
        return { values: [priceRange.low, priceRange.high] };
      });
    }
  }, [priceRange]);

  // Sync slider when price range data arrives
  // useEffect(() => {
  //   if (priceRange?.low != null && priceRange?.high != null) {
  //     setPriceState({ values: [priceRange.low, priceRange.high] });
  //   }
  // }, [priceRange]);

  // Re-query whenever any filter changes
  useEffect(() => {
    if (!priceState) return;   // ← must be FIRST, before the dispatch

    dispatch(
      query_products({
        webSiteOrigin:      sellerFrontendURL,
        low:                priceState.values[0] ?? '',
        high:               priceState.values[1] ?? '',
        category:           '',
        mainIngredient,
        FMP,
        cookingMethod,
        byThePan,
        dietaryRestrictions,
        cuisineType,
        holiday,
        rating,
        sortPrice,
        pageNumber,
      })
    );
  }, [
    dispatch,
    sellerFrontendURL,
    // priceState.values[0],
    // priceState.values[1],
    priceState,
    mainIngredient, FMP, cookingMethod, byThePan,
    dietaryRestrictions, cuisineType, holiday, rating, sortPrice, pageNumber,]);

  const resetFilter = useCallback(() => {
    setRating('');
    dispatch(price_range_product(sellerFrontendURL));
  }, [dispatch, sellerFrontendURL]);

  // ── Layout helpers ──────────────────────────────────────────────────────────
  const sidebarWidthClass = sellerBoolShowSidebar
    ? 'hidden'
    : 'w-3/12 md-lg:w-4/12';

  const mainWidthClass = sellerBoolShowSidebar
    ? 'w-full'
    : 'w-9/12 md-lg:w-8/12 md:w-full';

  const RATING_VALUES = [5, 4, 3, 2, 1];

  return (
    <div>
      <Header />
      <main>
        <section className="">
          <div className="">
            {/*  w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto  */}
            <div className="">
              <ShopBanner
                homePage="Home"
                homeLink="/"
                currentPageTop={`${sellerMainIngredientTerm} Page`}
                currentPageTopLink=""
                currentPageBottom1={mainIngredient}
                currentPageBottomLink1={`/productsMainIngredient?mainIngredient=${mainIngredient}`}
                currentPageBottom2=""
                currentPageBottomLink2=""
              />
            </div>
            <div style={{ backgroundColor: sellerComponentBackgroundColor }}>
              <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pt-4 border-none border-black">
                {/* ── Mobile filter toggle ── */}
                <div className={`md:block hidden ${!filter ? 'mb-6' : 'mb-0'}`}>
                  <button
                    onClick={() => setFilter((prev) => !prev)}
                    className="text-center rounded-lg w-full py-2 px-3 text-white"
                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                    Filter {sellerProductPluralTerm}
                  </button>
                </div>

                <div className="w-full flex flex-wrap">
                  {/* ── Sidebar ── */}
                  <aside
                    className={`${sidebarWidthClass} md:w-full pr-8
                      ${filter ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0'}`}>
                    {/* Price range */}
                    {sellerBoolShowSitePayments && priceState && (
                      <div className="py-2 flex flex-col gap-2">
                        <div className="text-2xl font-bold mb-3" 
                          style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                          Price
                        </div>
                        <Range
                          step={intPriceRangeStep}
                          min={low}
                          max={high}
                          values={priceState.values}
                          onChange={(values) => setPriceState({ values })}
                          renderTrack={({ props, children }) => (
                            <div
                              {...props}
                              className="ml-3 w-[92%] h-[6px] bg-slate-200 rounded-full cursor-pointer">
                              {children}
                            </div>
                          )}
                          renderThumb={({ props }) => (
                            <div
                              className="w-[15px] h-[15px] bg-[#059473] rounded-full"
                              {...props}
                            />
                          )}
                        />
                        <div>
                          <span className="ml-1 font-bold text-lg" 
                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                            {
                              //${Math.floor(priceState.values[0])} – ${Math.floor(priceState.values[1])}
                            }
                            

                            ${Math.floor(priceState?.values[0] ?? low)} – ${Math.floor(priceState?.values[1] ?? high)}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Star rating filter */}
                    {sellerBoolShowSiteRating && (
                      <div className="py-3 flex flex-col gap-2">
                        <div className="text-2xl font-bold mb-1" 
                          style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                          Rating
                        </div>
                        <div className="ml-1 flex flex-col gap-3">
                          {RATING_VALUES.map((val) => (
                            <StarRating
                              key={val}
                              value={val}
                              onSelect={setRating}
                              primaryColor={sellerPrimaryColor1 + sellerColorSuffixDark}
                            />
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Reset button — only shown when at least one filter section is visible */}
                    {(sellerBoolShowSitePayments || sellerBoolShowSiteRating) && (
                      <button
                        onClick={resetFilter}
                        style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}
                        className="text-center rounded-lg w-full py-2 px-3 text-white mt-2">
                        Reset Filter
                      </button>
                    )}

                    {/* Latest products (desktop only) */}
                    {sellerBoolShowSiteProductsUnderFilter && (
                      <div className="py-5 flex flex-col gap-4 md:hidden">
                        <Products
                          title={`Latest ${sellerProductPluralTerm}`}
                          products={latest_product}
                          parentPage="MainIngredientShop"
                        />
                      </div>
                    )}
                  </aside>

                  {/* ── Product grid ── */}
                  <div className={mainWidthClass}>
                    <div className={`${sellerBoolShowSidebar ? '' : 'pl-8'} md:pl-0`}>
                      {/* Toolbar */}
                      <div className="bg-white">
                        <div className="px-3 py-1 mb-2 gap-0.5 rounded-lg flex justify-between items-center border"
                          style={{
                              color: sellerPrimaryColor1 + sellerColorSuffixDark,
                              borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                              backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                          }}>
                          <div className="text-[18px] font-medium" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            {totalProduct}&nbsp;
                            {sellerProductTerm}
                            {totalProduct !== 1 && 's'}
                            {mainIngredient && ` (${mainIngredient})`}
                          </div>

                          <div className="flex justify-center items-center gap-2 ml-auto">
                              {sellerBoolShowSitePayments && (
                                  <select
                                      onChange={(e) => setSortPrice(e.target.value)}
                                      className="py-1.5 px-2.5 rounded-lg border text-sm font-medium outline-none bg-white cursor-pointer"
                                      style={{
                                          color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                          borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                      }}>
                                      <option value="">Sort By</option>
                                      <option value="low-to-high">Price: Low → High</option>
                                      <option value="high-to-low">Price: High → Low</option>
                                  </select>
                              )}
                      
                              {/* Grid / List toggle */}
                              <div
                                  className="flex rounded-lg border overflow-hidden md-lg:hidden"
                                  style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                  <button
                                      onClick={() => setStyles('grid')}
                                      className="p-1.5 transition-colors"
                                      style={{
                                          backgroundColor: styles === 'grid' ? sellerPrimaryColor1 + sellerColorSuffixLight : 'white',
                                          color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                      }}>
                                      <BsFillGridFill size={16} />
                                  </button>
                                  <button
                                      onClick={() => setStyles('list')}
                                      className="p-1.5 transition-colors"
                                      style={{
                                          backgroundColor: styles === 'list' ? sellerPrimaryColor1 + sellerColorSuffixLight : 'white',
                                          color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                          borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                      }}>
                                      <FaThList size={16} />
                                  </button>
                              </div>

                            {/* Grid / List toggle
                            <div className="hidden flex justify-center items-start gap-4 md-lg:hidden">
                              <button
                                aria-label="Grid view"
                                onClick={() => setStyles('grid')}
                                className={`p-2 ${styles === 'grid' ? 'bg-slate-300' : ''} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}
                              >
                                <BsFillGridFill style={{ color: sellerPrimaryColor1 }} />
                              </button>
                              <button
                                aria-label="List view"
                                onClick={() => setStyles('list')}
                                className={`p-2 ${styles === 'list' ? 'bg-slate-300' : ''} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}
                              >
                                <FaThList style={{ color: sellerPrimaryColor1 }} />
                              </button>
                            </div>
                          */}
                          </div>
                        </div>
                      </div>
                      {/* Products */}
                      <div className="pb-8">
                        <ShopProductGridListView products={products} styles={styles} />
                      </div>

                      {/* Pagination */}
                      {totalProduct > parPage && (
                        <Pagination
                          pageNumber={pageNumber}
                          setPageNumber={setPageNumber}
                          totalItems={totalProduct}
                          parPage={parPage}
                          showItem={Math.floor(totalProduct / parPage)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default MainIngredientShop;









//my original code
// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useSearchParams } from 'react-router-dom';
// import { Range } from 'react-range';

// import { IoIosArrowForward } from "react-icons/io";
// import {AiFillStar} from 'react-icons/ai'
// import {CiStar} from 'react-icons/ci' 
// import {BsFillGridFill} from 'react-icons/bs'
// import {FaThList} from 'react-icons/fa'

// import { price_range_product, query_products } from '../store/reducers/homeReducer';

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import Products from '../components/products/Products';
// import Pagination from '../components/Pagination';
// import ShopBanner from '../components/ShopBanner';
// import ShopProductGridListView from '../components/products/ShopProductGridListView';

// import config from '../config';

// const MainIngredientShop = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const intPriceRangeStep = config.INT_FRONTEND_PRICE_RANGE_STEP
    
//     const { products, priceRange, latest_product, totalProduct, parPage } = useSelector(state => state.home)
//     const { seller } = useSelector(state => state.seller)
    
//     const sellerId = seller?._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerProductTerm = seller?.productTerm
//     const sellerProductPluralTerm = seller?.productPluralTerm 
//     const sellerMainIngredientTerm = seller?.mainIngredientTerm

//     const sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller?.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteProductsUnderFilter = seller?.isVisibleSiteProductsUnderFilter === 'Show' ? true : false

//     let sellerBoolShowSidebar = true
//     if(sellerBoolShowSitePayments || sellerBoolShowSiteRating || sellerBoolShowSiteProductsUnderFilter) 
//         { sellerBoolShowSidebar = false }
//     else 
//         { sellerBoolShowSidebar = true }
    
//     let [searchParams, setSearchParams] = useSearchParams()
//     const category = ''
//     const mainIngredient = searchParams.get('mainIngredient')
//     const [FMP, setFmp] = useState('')
//     const [cookingMethod, setCookingMethod] = useState('')
//     const [byThePan, setByThePan] = useState('')
//     const [dietaryRestrictions, setDietaryRestrictions] = useState('')
//     const [cuisineType, setCuisineType] = useState('')
//     const [holiday, setHoliday] = useState('')
//     //console.log(mainIngredient)

//     const dispatch = useDispatch()
    
//     useEffect(() => { 
//         dispatch(price_range_product(sellerFrontendURL))
//     },[])
    
//     useEffect(() => { 
//         setState({
//             values: [priceRange.low, priceRange.high]
//         })
//     },[priceRange])

//     const [filter, setFilter] = useState(true) 

//     const [state, setState] = useState({values: [priceRange.low, priceRange.high]})
//     //console.log(priceRange.low)
//     //console.log(priceRange.high)

//     //const priceRangeMinPrice = state.priceRange.low || 0; 
//     //const priceRangeMaxPrice = state.priceRange.high || 100;

//     const [rating, setRating] = useState('')
//     const [styles, setStyles] = useState('grid')

//     const [pageNumber, setPageNumber] = useState(1)
//     const [sortPrice, setSortPrice] = useState('') 

//     useEffect(() => { 
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontendURL,
//                 low: state.values[0] || '',
//                 high: state.values[1] || '',
//                 category,
//                 mainIngredient,
//                 FMP,
//                 cookingMethod,
//                 byThePan,
//                 dietaryRestrictions,
//                 cuisineType,
//                 holiday,
//                 rating,
//                 sortPrice,
//                 pageNumber
//             })
//          )
//     },[sellerFrontendURL, state.values[0], state.values[1], category, mainIngredient, FMP, cookingMethod, byThePan, dietaryRestrictions, cuisineType, holiday, rating, sortPrice, pageNumber])
    
//     const resetFilter = () => {
//         setRating('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontendURL,
//                 low: state.values[0],
//                 high: state.values[1],
//                 category,
//                 mainIngredient: '',
//                 rating: '',
//                 sortPrice,
//                 pageNumber
//             })
//          )
//          dispatch(price_range_product(sellerFrontendURL))
//     }

//     //console.log(products)

//     return (
//         <div>
//             <Header/>
//             <section className='py-2'>
//                 <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                     <div className='mb-2'>
//                         <ShopBanner homePage={'Home'} homeLink={'/'} currentPageTop={sellerMainIngredientTerm + ' Page'} currentPageTopLink={''} 
//                             currentPageBottom1={mainIngredient} currentPageBottomLink1={'/productsMainIngredient?mainIngredient=' + mainIngredient} 
//                             currentPageBottom2={''} currentPageBottomLink2={''} />
//                     </div>       
//                     <div className={` md:block hidden ${!filter ? 'mb-6' : 'mb-0'} `}>
//                         <button onClick={() => setFilter(!filter)} 
//                         className='text-center rounded-lg w-full py-2 px-3 text-white' 
//                             style={{backgroundColor:sellerPrimaryColor1}}>
//                             Filter {sellerProductPluralTerm}
//                         </button> 
//                     </div>
//                     <div className='w-full flex flex-wrap'>
//                         <div className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 
//                             ${filter ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0' } `}>
//                             <div className={` ${sellerBoolShowSitePayments ? 'py-2 flex flex-col gap-5' : 'hidden'} `}>
//                                 <h2 className='text-2xl font-bold mb-3' style={{color:sellerPrimaryColor1}}>Price</h2>
//                                 <Range
//                                 step={intPriceRangeStep} 
//                                     min={priceRange.low} // priceRangeMinPrice 
//                                     max={priceRange.high} // priceRangeMaxPrice
//                                     values={(state.values)} onChange={(values) => setState({values})}
//                                     renderTrack={({props,children}) => (
//                                         <div {...props} className='w-full h-[6px] bg-slate-200 rounded-full cursor-pointer'>
//                                             {children}
//                                         </div>
//                                     )}
//                                     renderThumb={({ props }) => (
//                                         <div className='w-[15px] h-[15px] bg-[#059473] rounded-full' {...props} />
//                                     )} 
//                                 />  
//                                 <div>
//                                     <span className='font-bold text-lg' style={{color:sellerPrimaryColor1}}>${Math.floor(state.values[0])} - ${Math.floor(state.values[1])}</span>  
//                                 </div>
//                             </div>
//                             <div className={` ${sellerBoolShowSiteRating ? 'py-3 flex flex-col gap-4' : 'hidden'} `}>
//                                 <h2 className='text-2xl font-bold mb-3' style={{color:sellerPrimaryColor1}}>Rating</h2>
//                                 <div className='flex flex-col gap-3'>
//                                     <div onClick={() => setRating(5)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(4)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(3)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(2)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(1)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div> 
//                                 </div>
//                             </div>
//                             <button onClick={resetFilter} style={{backgroundColor:sellerPrimaryColor1}} 
//                                 className={` ${(!sellerBoolShowSitePayments && !sellerBoolShowSiteRating) ? 'hidden' : ''} 
//                                     text-center rounded-lg w-full py-2 px-3 text-white`}>
//                                 Reset Filter
//                             </button> 
//                             <div className={` ${sellerBoolShowSiteProductsUnderFilter ? '' : 'hidden'} py-5 flex flex-col gap-4 md:hidden`}>
//                                 <Products title={'Latest '+ sellerProductPluralTerm} products={latest_product}  parentPage={'MainIngredientShop'} />
//                             </div> 
//                         </div>
//                         <div className={` ${sellerBoolShowSidebar ? '' : 'w-9/12 md-lg:w-8/12'} md:w-full`}>
//                             <div className={` ${sellerBoolShowSidebar ? '' : 'pl-8'} md:pl-0`}>
//                                 <div className='py-2 bg-white mb-10 px-3 rounded-md flex justify-between items-start border'>
//                                     <h2 className='text-lg font-medium' style={{color:sellerPrimaryColor1}}> 
//                                         {totalProduct} {sellerProductTerm}
//                                         <span className= {` ${totalProduct > 1 ? '': 'hidden'} `} >s </span>
//                                         ({mainIngredient})
//                                     </h2>
//                                     <div className='flex justify-center items-center gap-3'>
//                                         <select onChange={(e)=>setSortPrice(e.target.value)}  name="" id=""
//                                             className='p-1 border outline-0 font-semibold' style={{color:sellerPrimaryColor1}}>
//                                             <option value="">Sort By</option>
//                                             <option className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `} value="low-to-high">Low to High Price</option>
//                                             <option className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `}  value="high-to-low">High to Low Price </option>
//                                         </select>
//                                         <div className='flex justify-center items-start gap-4 md-lg:hidden'>
//                                                 <div onClick={()=> setStyles('grid')} 
//                                                     className={`p-2 ${styles === 'grid' && 'bg-slate-300'} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm `} >
//                                                     <BsFillGridFill style={{color:sellerPrimaryColor1}} />  
//                                                 </div>
//                                                 <div onClick={()=> setStyles('list')} 
//                                                     className={`p-2 ${styles === 'list' && 'bg-slate-300'} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm `} >
//                                                     <FaThList style={{color:sellerPrimaryColor1}} />  
//                                                 </div> 
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className='pb-8'>
//                                         <ShopProductGridListView products={products} styles={styles} />  
//                                     </div>
//                                     <div>
//                                     {totalProduct > parPage &&  
//                                         <Pagination 
//                                             pageNumber={pageNumber} 
//                                             setPageNumber={setPageNumber} 
//                                             totalItems={totalProduct} 
//                                             parPage={parPage} 
//                                             showItem={Math.floor(totalProduct / parPage )} />
//                                     }
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             <Footer/>
//         </div>
//     );
// };

// export default MainIngredientShop;




